/** Design tokens aligned with testgate_mockup.html */
export const roleColors = {
  topbar: '#0f172a',
  primary: '#cc0000',
  primaryHover: '#a80000',
  activeNavBg: '#faf0f1',
  activeNavText: '#a80000',
  pageBg: '#f1f5f9',
  cardBorder: '#e2e8f0',
  text: '#0f172a',
  textMuted: '#64748b',
  textLight: '#94a3b8',
  green: '#10b981',
  red: '#ef4444',
  orange: '#f97316',
  yellow: '#fbbf24',
};

export const clientColors = roleColors;

export const severityBadge = {
  critical: { bg: '#fee2e2', color: '#dc2626', label: 'Critical' },
  high: { bg: '#ffedd5', color: '#ea580c', label: 'High' },
  medium: { bg: '#fef9c3', color: '#b45309', label: 'Medium' },
  low: { bg: '#dcfce7', color: '#16a34a', label: 'Low' },
};

export const statusBadge = {
  new: { bg: '#f1f5f9', color: '#64748b', label: 'New' },
  open: { bg: '#fef9c3', color: '#b45309', label: 'Under Review' },
  'under review': { bg: '#fef9c3', color: '#b45309', label: 'Under Review' },
  accepted: { bg: '#dcfce7', color: '#16a34a', label: 'Accepted' },
  verified: { bg: '#fff1f2', color: '#a80000', label: 'Verified' },
  resolved: { bg: '#dcfce7', color: '#16a34a', label: 'Accepted' },
  'in-progress': { bg: '#fff1f2', color: '#a80000', label: 'In Review' },
  closed: { bg: '#f1f5f9', color: '#64748b', label: 'Closed' },
  rejected: { bg: '#fee2e2', color: '#dc2626', label: 'Rejected' },
  pending: { bg: '#fef9c3', color: '#b45309', label: 'Pending' },
};

export const cycleTypeBadge = {
  regression: { bg: '#fff1f2', color: '#a80000', label: 'Regression' },
  uat: { bg: '#faf0f1', color: '#a80000', label: 'UAT' },
  functional: { bg: '#fff1f2', color: '#a80000', label: 'Functional' },
  exploratory: { bg: '#f1f5f9', color: '#64748b', label: 'Exploratory' },
  usability: { bg: '#fef9c3', color: '#b45309', label: 'Usability' },
  security_testing: { bg: '#fee2e2', color: '#dc2626', label: 'Security' },
};

export function progressBarColor(pct) {
  if (pct >= 75) return roleColors.green;
  if (pct >= 60) return '#3b82f6';
  if (pct >= 45) return roleColors.orange;
  return roleColors.red;
}

export function initialsFromName(name) {
  if (!name) return '?';
  const parts = String(name).trim().split(/\s+/);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export const btnPrimarySx = {
  px: 1.5,
  py: 0.625,
  borderRadius: '7px',
  bgcolor: roleColors.primary,
  color: '#fff',
  fontSize: 11.5,
  fontWeight: 600,
  border: 'none',
  cursor: 'pointer',
  '&:hover': { bgcolor: roleColors.primaryHover },
};

export const btnDangerSx = {
  px: 1.5,
  py: 0.625,
  borderRadius: '7px',
  bgcolor: '#ef4444',
  color: '#fff',
  fontSize: 11.5,
  fontWeight: 600,
  border: 'none',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  '&:hover': { bgcolor: '#dc2626' },
};

export const formSelectSx = {
  padding: '9px 12px',
  border: '1.5px solid #e2e8f0',
  borderRadius: '7px',
  fontSize: 13,
  color: '#1e293b',
  background: '#fff',
  minWidth: 160,
};

export const formInputSx = {
  flex: 1,
  padding: '9px 12px',
  border: '1.5px solid #e2e8f0',
  borderRadius: '7px',
  fontSize: 13,
  color: '#1e293b',
  background: '#fff',
  width: '100%',
};

export const btnSecondarySx = {
  px: 1.5,
  py: 0.625,
  borderRadius: '7px',
  border: `1px solid ${roleColors.cardBorder}`,
  bgcolor: '#f1f5f9',
  color: '#374151',
  fontSize: 11.5,
  fontWeight: 600,
  cursor: 'pointer',
  '&:hover': { bgcolor: '#e2e8f0' },
};
